export interface SubscriberSummary {
  BoxId?: string;
  'Tipo de assinante'?: string;
  Nome?: string;
  Telefone?: string;
  CPF?: string;
  'E-mail'?: string;
  Assinatura?: string;
  Plano?: string;
  Joia?: string;
  Status?: string;
  Edição?: string;
  Produto?: string;
  Cupom?: string;
  Composição?: string;
  Total?: string;
  'Data Pagamento'?: string;
  'Link Admin'?: string;
  'Motivo de falha'?: string;
  'Status edição'?: string;
  'Status Millennium'?: string;
}
